import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'

export const DevicesRow = styled(Row)`
    margin: 0;
    padding: 0 8px;
`

export const DevicesListItemCol = styled(Col)`
    padding: 7px;
`

export const DeviceListItem = styled(Link)`
    color: #000;
    
    &:hover {
        color: #000;
    }
`

export const DeviceListImage = styled.img`
    object-fit: ${props => (props.contain ? 'contain' : 'cover')};
    width: 100%; 
    height: 150px;
    background-color: transparent;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
`

export const DeviceListItemContent = styled.div`
    border: 1px solid rgba(136,136,136, 0.3);
    border-radius: 10px; 
    box-shadow: 0 0 10px rgba(136,136,136, 0.4);
`

export const DeviceListItemInnerContent = styled.div`
    width: 100%;
    height: 90px;
    text-align: center;
    padding: 10px 0;
    position: relative;
`

export const ValveListItemInnerContent = styled(DeviceListItemInnerContent)`
    height: 120px;
`

export const DeviceItemName = styled.div`
    line-height: 30px;
    font-size: 0.9rem;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const DeviceItemSubvalue = styled.div`
    font-size: 0.9rem;
    font-weight: 300;
    color: var(--secondary);
    line-height: 20px;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
`

export const DeviceMoistureIcon = styled.div`
    width: 30px;
    height: 30px;
    background: url(${props => props.image});
    background-size: contain;
    top: 0;
    left: 0;
    position: absolute;
`

export const DeviceMoistureIconWrapper = styled.div`
    width: 40px;
    height: 40px;
    position: absolute;
    left: 20px;
    ${props => (props.top ? `top: ${props.top}px` : '')};
    ${props => (props.bottom ? `bottom: ${props.bottom}px` : '')};
`

export const DeviceMoistureIconText = styled.div`
    width: 24px;
    height: 40px;
    top: 10px;
    left: 30px;
    position: absolute;
    font-size: 15px;
    color: var(--cyan);
`

export const ValveWateringIconText = styled(DeviceMoistureIconText)`
    width: 55px;
    top: 30px;
    left: 0;
    font-size: 12px;
`

export const DeviceBatteryIconWrapper = styled.div`
    width: 40px;
    height: 40px;
    position: absolute;
    right: 20px;
    ${props => (props.top ? `top: ${props.top}px` : '')};
    ${props => (props.bottom ? `bottom: ${props.bottom}px` : '')};
`

export const DeviceBatteryIcon = styled.div`
    width: 40px;
    height: 40px;
    background: url(${props => props.image});
    top: 0;
    right: 0;
    position: absolute;
`

export const DeviceBatteryIconText = styled.div`
    width: 24px;
    height: 40px;
    top: 11px;
    right: 10px;
    position: absolute;
    font-size: 12px;
    color: var(--${props => props.textColor});
`

export const AddDeviceActionButton = styled(Link)`
    position: absolute;
    right: 25px;
    bottom: 4px;
    color: darkgray;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Devices/DeviceList.js